// removed by extract-text-webpack-plugin
module.exports = {"error":"dh-stemning-error"};


//////////////////
// WEBPACK FOOTER
// ./src/shared/components/Error/Error.css
// module id = 61
// module chunks = 0 1